import type { RouteLocationNamedRaw } from 'vue-router'
import { route, router } from './util'

export const getUrl = (to: RouteLocationNamedRaw, defaultUrl: string) => {
  try {
    const target = router.resolve({
      ...to,
      params: { ...route.value.params },
      query: { ...(to.query || {}), ref: location.href },
    })
    return target.href
  } catch (e) {
    return `${defaultUrl}${defaultUrl.includes('?') ? '&' : '?'}ref=${encodeURIComponent(location.href)}`
  }
}

export const gotoLogin = () => {
  location.href = getUrl({ name: 'Login' }, `${import.meta.env.VITE_SITE_URL}/Login`)
}
